import _ from "lodash";
import { Action } from "../../../actions/actions";
import { HallsActionTypes } from "../actions/actionTypes";
import { HallFilterTypes, HallListViews } from "../types/filters";

export interface HallsListFilters {
    market: string[];
    country: string[];
    search: string;
    provider: string[];
    serverStatus: string | null;
    hallStatus: string | null;
    viewMode: string;
}

export const initialState: HallsListFilters = {
    market: [],
    country: [],
    search: "",
    provider: [],
    serverStatus: "",
    hallStatus: "1",
    viewMode: HallListViews.GRID
};

export function hallsListFilters(
    state: HallsListFilters = initialState,
    action: Action
) {
    let newState: HallsListFilters = _.cloneDeep(state);

    switch (action.type) {
        case HallsActionTypes.CLEAR_HALL_LIST_FILTER:
            if (action.payload === HallFilterTypes.MARKET) {
                newState.market = [];
            }else if (action.payload === HallFilterTypes.COUNTRY) {
                newState.country = [];
            } else if (action.payload === HallFilterTypes.SEARCH) {
                newState.search = "";
            } else if (action.payload === HallFilterTypes.PROVIDER) {
                newState.provider = [];
            } else if (action.payload === HallFilterTypes.SERVER_TYPE) {
                newState.serverStatus = "";
            } else if (action.payload === HallFilterTypes.HALL_STATUS) {
                newState.hallStatus = "1";
            }

            return newState;

        case HallsActionTypes.CLEAR_HALL_LIST_FILTERS:
            newState = initialState;
            newState.viewMode = state.viewMode;
            return initialState;

        case HallsActionTypes.CHANGE_HALL_LIST_FILTER:
            if (action.payload.type === HallFilterTypes.MARKET) {
                newState.market = [...action.payload.filterValues];
            } else if (action.payload.type === HallFilterTypes.COUNTRY) {
                newState.country = [...action.payload.filterValues];
            } else if (action.payload.type === HallFilterTypes.SEARCH) {
                newState.search = action.payload.filterValues[0];
            } else if (action.payload.type === HallFilterTypes.PROVIDER) {
                newState.provider = [...action.payload.filterValues];
            } else if (action.payload.type === HallFilterTypes.SERVER_TYPE) {
                newState.serverStatus = action.payload.filterValues[0];
            } else if (action.payload.type === HallFilterTypes.VIEW_MODE) {
                newState.viewMode = action.payload.filterValues[0];
            } else if (action.payload.type === HallFilterTypes.HALL_STATUS) {
                newState.hallStatus = action.payload.filterValues[0];
            }
            return newState;

        default:
            return state;
    }
}
